import React, { useState } from 'react';
import './Press.css';

function Press() {

    const [selectedYear, setSelectedYear] = useState(null);

    const interviews = {
        2023: [
            { date: '2023-05-24', title: 'Проект «Наша музыка»', publication: 'РАДИО АСТВ', link: 'https://vk.com/wall-209960938_44' },
        ],
        2022: [
            { date: '2022-02-13', title: 'Проект «Наша музыка»', publication: 'эфир Радио АСТВ', link: 'https://vk.com/wall-209960938_12'},
        ],
        2024: [
            { date: '2024-07-05', title: 'Проект «Наша музыка»', publication: 'эфир Радио АСТВ', link: 'https://vk.com/wall-209960938_121' },
            { date: '2024-07-24', title: 'Сахалинская группа Mintskoplenok — о своем становлении и первом концерте', publication: 'sakh.online', link: 'https://sakh.online/news/18/2024-07-24/sahalinskaya-gruppa-mintskoplenok-o-svoem-stanovlenii-i-pervom-kontserte-430284' },
            { date: '2024-07-21', title: 'Хит-парад', publication: 'эфир Радио Тихий Дон', link: 'https://vk.com/wall-209960938_137' },
            { date: '2024-07-21', title: 'Южный. Квартирник', publication: 'ОТВ Сахалин', link: 'https://vk.com/wall-209960938_178' },
        ], 
    };

    const handleYearClick = (year) => {
        setSelectedYear(year === selectedYear ? null : year);
    };
    return (
       
         
            
         

            <section className="press-section">
                <h2>Выбирайте год</h2>
                <div className="year-selector">
                    {Object.keys(interviews).map((year) => (
                        <button
                            key={year}
                            className={`year-button ${selectedYear === parseInt(year) ? 'active' : ''}`}
                            onClick={() => handleYearClick(parseInt(year))}
                        >
                            {year}
                        </button>
                    ))}
                </div>

                <div className="interview-list">
                    {selectedYear && (
                        <>
                        <h3>Интервью с {selectedYear}</h3>
                            <ul>
                                {interviews[selectedYear].map((interview, index) => (
                                    <li key={index}>
                                        <p><strong>{interview.date}</strong> - <a href={interview.link} target="_blank" rel="noopener noreferrer">{interview.title}</a> ({interview.publication})</p>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </section>
       
    );
};

export default Press;